import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@app/shared/services/api.service';
import { StoreService } from '@app/shared/services/store.service';
import { theme } from '../../../../../data/theme';

@Component({
    selector: 'app-footer-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent {

    theme = theme;
    email: string;
    userForm: FormGroup;

    constructor(
        public store: StoreService,
        private api: ApiService,
        private formBuilder: FormBuilder
    ) {
        this.userForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]]
        });
    }

    onSubmit() {

        const model = {
            Email: this.userForm.value.email
        };

        if (this.userForm.invalid) {
            alert(this.store.getKeywords('please_enter_valid_email'));
            return;
        }

        this.api.subscribe(model).subscribe(x => {
            if (x.success) {
                alert(this.store.getKeywords('Congratulations,_your_subscription_is_complete'));
            } else {
                alert(x.message);
            }
        });

    }

}
